var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.4 24.4",
    style: {
      enableBackground: "new 0 0 24.4 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#121B24;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 12.2,
    r: 12.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3362,
    y1: 20.7301,
    x2: 8.3179,
    y2: 6.842,
    gradientTransform: "matrix(1 0 0 -1 0 26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AADB6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C4EA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,16.8c0.7,0.9,1.5,1.7,2.5,2.3c1,0.6,2.1,0.9,3.3,1.1c-0.6-0.9-1.5-1.7-2.5-2.3 C7.9,17.2,6.8,16.9,5.7,16.8z M10.4,15.4c-2.1-1.2-4.3-1.5-5.9-1c0.2,0.5,0.4,1,0.6,1.5c1.4,0,2.9,0.3,4.3,1.2 c1.4,0.8,2.5,2,3.2,3.2c0.5,0,1.1-0.1,1.6-0.2C13.9,18.4,12.5,16.6,10.4,15.4z M20.3,10.5c-0.3-1.1-0.7-2.1-1.4-3 c-0.7-0.9-1.5-1.6-2.4-2.2c-1-0.6-2-0.9-3.1-1s-2.2-0.1-3.3,0.2c1.8,0.2,3.7,0.9,5.7,2C17.7,7.7,19.2,9,20.3,10.5z M17.7,14.4 c-0.9-1.5-2.5-2.9-4.4-4.1c-1.9-1.1-3.9-1.7-5.7-1.8C6.1,8.5,4.9,9,4.5,9.8l0,0c0,0.2-0.1,0.3-0.1,0.5C5,10,5.8,9.8,6.6,9.8 c1.9,0,4,0.6,6,1.7s3.6,2.7,4.5,4.4c0.4,0.8,0.7,1.5,0.8,2.2c0.1-0.1,0.2-0.2,0.3-0.3l0,0C18.7,17,18.5,15.7,17.7,14.4z M11.9,12.8 c-2.9-1.7-6.2-2-7.7-0.8c0,0.4,0,0.7,0.1,1.1c0.5-0.1,0.9-0.2,1.4-0.3c1.7-0.1,3.7,0.4,5.4,1.4s3.1,2.4,3.9,4 c0.2,0.4,0.4,0.9,0.5,1.4c0.3-0.1,0.7-0.3,1-0.5C16.6,17.2,14.8,14.5,11.9,12.8z M19.2,11.9c-0.9-1.5-2.5-3-4.4-4.1S10.8,6,9.1,6 C7.7,6,6.7,6.3,6.2,6.9c2.2-0.4,5.2,0.3,8.1,1.9c2.9,1.7,4.9,3.9,5.7,6.1C20.2,14.1,19.9,13,19.2,11.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupIcon);
export default __webpack_public_path__ + "static/media/jup_icon.ef7d0de6ac1e32860453c4e5bcdc6439.svg";
export { ForwardRef as ReactComponent };